import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card, Space } from '@masterteam/mt-design-react';

import Item from './Item';

import './style.scss';

function HistoricalInfo({ data = [] }) {
  return (
    <Card className="historical-info">
      <Space className="historical-info__header">
        <FormattedMessage id="kpi-details.historical-info" />
      </Space>
      <Space direction="vertical">
        {data?.map((e) => (
          <Item data={e} />
        ))}
      </Space>
    </Card>
  );
}

export default HistoricalInfo;
